import React from 'react'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Text from 'core/elements/Text'
import PhysicalNodesTable from '../cluster/deployment/form-components/PhysicalNodesTable'
import { useErrorClearingSelectUpdater } from './hooks/useErrorClearingSelectUpdater'

const defaultPhysicalNodeErrors = { title: '', message: '' }

const ClusterMasterPhysicalNode = ({
  params,
  getParamsUpdater,
  setError,
  masterPhysicalNodeErrors = defaultPhysicalNodeErrors,
  setMasterPhysicalNodeErrors = undefined,
}) => {
  const handleSelectChange = useErrorClearingSelectUpdater(
    getParamsUpdater('masterPhysicalNodes'),
    setMasterPhysicalNodeErrors,
  )
  return (
    <>
      <Text variant="body2">Select the control plane nodes for cluster.</Text>
      <PhysicalNodesTable
        selectedNodes={params?.masterPhysicalNodes}
        setError={setError}
        label="Control Plane Nodes"
        onSelectChange={handleSelectChange}
      />
      {masterPhysicalNodeErrors && (
        <ErrorMessage data-testid="master-physical-node-error">
          {masterPhysicalNodeErrors.message}
        </ErrorMessage>
      )}
    </>
  )
}

export default ClusterMasterPhysicalNode
